import {
  getCurrentTokenWithoutRedirect,
  getEnv,
  getRegion,
  ENVS,
  REGIONS,
} from "@adsk/acs-sc-web-platform-api";
import {
  addXDestinationHandlerHeaderTransformer,
  addXRequestedByHeaderTransformer,
  buildServiceUrlRequestTransformer,
  buildRequestHeadersTransformer,
  buildUrlPrefixTransformer,
} from "./RawApiClient";
const FUNCTION_NAME = "goldenGateRequestTransformer";
const URL_SCHEME = "https://";
export const DOMAINS = {
  [REGIONS.US]: {
    DEV: "io.plangrid-dev.planfront.net",
    TEST: "io.plangrid-test.planfront.net",
    PROD: "io.app.plangrid.com",
  },
  [REGIONS.EMEA]: {
    PROD: "io.app.plangrid.be",
  },
};
export const getDomain = stack => {
  let region = "";
  try {
    region = getRegion();
  } catch (ex) {
    region = REGIONS.US;
  }
  try {
    return DOMAINS[region][stack];
  } catch (ex) {
    return DOMAINS[REGIONS.US].PROD;
  }
};
const PLANWEB_DOMAINS = {
  DEV: getDomain("DEV"),
  TEST: getDomain("TEST"),
  PROD: getDomain("PROD"),
};
export const STACK_TO_PROXY_DOMAIN_MAPPING = {
  // Use PlanWeb domains
  dev: PLANWEB_DOMAINS.DEV,
  "dev-gg": PLANWEB_DOMAINS.DEV,
  test: PLANWEB_DOMAINS.TEST,
  "test-gg": PLANWEB_DOMAINS.TEST,
  prod: PLANWEB_DOMAINS.PROD,
  "prod-gg": PLANWEB_DOMAINS.PROD,
  [ENVS.QA]: PLANWEB_DOMAINS.DEV,
  [ENVS.STAGING]: PLANWEB_DOMAINS.TEST,
  [ENVS.PRODUCTION]: PLANWEB_DOMAINS.PROD,
};
export const STACK_TO_PROXY_URL_MAPPING = Object.entries(
  STACK_TO_PROXY_DOMAIN_MAPPING
).reduce((mapping, [key, value]) => {
  mapping[key] = `${URL_SCHEME}${value}`;
  return mapping;
}, {});
export const getServiceUrl = proxyDomain => `${URL_SCHEME}${proxyDomain}`;
export default function goldenGateRequestTransformer(serviceName) {
  if (typeof window === "undefined") {
    const message = `\`${FUNCTION_NAME}("${serviceName}")\` is only supported for browser clients.`;
    return r => {
      console.error(message); // tslint:disable-line:no-console
      return r;
    };
  }
  const stack = process.env.STACK;
  let ACS_ENV = "";
  try {
    ACS_ENV = getEnv();
  } catch (ex) {}
  let error;
  if (stack && !(stack in STACK_TO_PROXY_URL_MAPPING)) {
    error = `"${stack}" stack is not supported.`;
  }
  if (!stack && !(ACS_ENV in STACK_TO_PROXY_URL_MAPPING)) {
    error = !ACS_ENV
      ? `Failed to get ACS env`
      : `"${ACS_ENV}" ACS env is not supported.`;
  }
  if (error) {
    return r => {
      console.error(error); // tslint:disable-line:no-console
      return r;
    };
  }
  return async urlAndInit => {
    const serviceUrl = getServiceUrl(
      STACK_TO_PROXY_DOMAIN_MAPPING[stack] ||
        STACK_TO_PROXY_DOMAIN_MAPPING[ACS_ENV]
    );
    const serviceUrlRequestTransformer = buildServiceUrlRequestTransformer(
      serviceUrl
    );
    const PROXY_PREFIX = "proxy";
    const urlPrefixTransformer = buildUrlPrefixTransformer(
      serviceUrl,
      PROXY_PREFIX,
      serviceName
    );
    const headers = {};
    try {
      const { accessToken } = await getCurrentTokenWithoutRedirect();
      headers.authorization = "Bearer " + accessToken;
    } catch (e) {}
    const authorizationHeaderTransformer = buildRequestHeadersTransformer(
      headers
    );
    return authorizationHeaderTransformer(
      addXDestinationHandlerHeaderTransformer(
        addXRequestedByHeaderTransformer(
          urlPrefixTransformer(
            serviceUrlRequestTransformer(
              authorizationHeaderTransformer(urlAndInit)
            )
          )
        )
      )
    );
  };
}
